import React from 'react';
import {
  getPropertyListingMode,
  getPropertyCardImage,
  getEffectiveMinInvestment,
} from '../../utils/properties';
import { formatExactMoney, formatExactShareMoney } from '../../data/countries';

const CompareModal = ({ list, onClose, onSelect, country }) => {
  if (!list || list.length === 0) return null;
  return (
    <div className="compare-modal-backdrop" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="compare-modal-title">
      <div className="compare-modal-panel" onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem", paddingBottom: "1rem", borderBottom: "1px solid var(--border)" }}>
          <h2 id="compare-modal-title" style={{ margin: 0, fontSize: "1.15rem", display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <i className="fas fa-right-left" style={{ color: "var(--primary)" }}></i>
            Side-by-side comparison
          </h2>
          <button type="button" className="btn btn-ghost btn-sm" onClick={onClose} aria-label="Close comparison">×</button>
        </div>
        <div className="compare-modal-grid">
          {list.map((prop) => {
            const isRent = getPropertyListingMode(prop) === "rent";
            const pricePerShare = prop.shares ? prop.price / prop.shares : 0;
            const progress = prop.shares ? (prop.sharesSold / prop.shares) * 100 : 0;
            return (
              <div key={prop.id} className="compare-modal-card">
                <img src={getPropertyCardImage(prop)} alt={prop.title} />
                <div className="compare-modal-card-body">
                  <h3>{prop.title}</h3>
                  <p style={{ color: "var(--text-light)", fontSize: "0.8rem", margin: "0 0 0.5rem" }}>
                    <i className="fas fa-map-marker-alt" style={{ color: "var(--accent)", marginRight: "0.25rem" }}></i>
                    {prop.location}
                  </p>
                  <p style={{ fontSize: "1.1rem", fontWeight: 800, color: "var(--primary)", margin: 0 }}>
                    {isRent
                      ? (Number(prop.monthlyRent) > 0 ? `${formatExactMoney(prop.monthlyRent, country)}/mo` : "Contact for rate")
                      : formatExactMoney(prop.price, country)}
                  </p>
                  <div className="compare-modal-stats">
                    <p><strong>Type:</strong> {prop.type || "—"}</p>
                    <p><strong>Listing:</strong> {isRent ? "Rent" : "Sale / co-own"}</p>
                    <p><strong>Bedrooms:</strong> {prop.beds ?? "—"}</p>
                    <p><strong>Bathrooms:</strong> {prop.baths ?? "—"}</p>
                    {!isRent && (
                      <>
                        <p><strong>Target return:</strong> {prop.projectedReturn != null ? `${prop.projectedReturn}%` : "—"}</p>
                        <p><strong>Min investment:</strong> {prop.shares ? formatExactMoney(getEffectiveMinInvestment(prop), country) : "—"}</p>
                        <p><strong>Share price:</strong> {prop.shares ? formatExactShareMoney(pricePerShare, country) : "—"}</p>
                        <p><strong>Funding:</strong> {prop.shares ? `${progress.toFixed(0)}% (${prop.sharesSold}/${prop.shares} shares)` : "—"}</p>
                      </>
                    )}
                    {isRent && Number(prop.monthlyRent) > 0 && (
                      <p><strong>Monthly rent:</strong> {formatExactMoney(prop.monthlyRent, country)}</p>
                    )}
                    <p><strong>Area:</strong> {prop.sqft ? `${prop.sqft} sqft` : "—"}</p>
                  </div>
                </div>
                <div className="compare-modal-card-footer">
                  <button type="button" className="btn btn-primary" style={{ width: "100%" }} onClick={() => { onSelect(prop); onClose(); }}>
                    View listing
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CompareModal;
